import React from 'react'
import type { PresentationIsEmptyProps, PresentationSectionProps } from '../../'
import compareSectionProps from '../../util/compareSectionProps'

interface V1PartnerSectionModule {
  Section: React.ComponentType<any>
  isEmpty: (props: PresentationIsEmptyProps) => boolean
}

/**
 * Wraps a v1 partner-content section module (Sherwin-Williams / Benjamin Moore) into the v2
 * registration contract (#21311). The v1 partner sections are static marketing content — they
 * read no section.fields and only use `section`/`classes` from their props — so v2 reuses them
 * directly instead of duplicating them. Unlike native v2 sections they don't render
 * `WrapperComponent` themselves, so the adapter wraps them.
 */
export default function createPartnerSectionModule(v1Module: V1PartnerSectionModule) {
  const V1Section = v1Module.Section

  function PartnerSection(props: PresentationSectionProps) {
    const { WrapperComponent } = props
    return (
      <WrapperComponent {...props}>
        <V1Section {...props} />
      </WrapperComponent>
    )
  }

  return {
    isEmpty: (_props: PresentationIsEmptyProps) => false,
    Section: React.memo(PartnerSection, compareSectionProps)
  }
}
